<template>
  <v-card>
    <v-card-text style="text-align: center; width: 100%" align-content-center v-if="!solicitacao">

      <v-data-table
          ref="selecaoTodos"
          :headers="headers"
          :items="criterios"
          v-model="selected"
          item-key="id"
          class="elevation-1"
      >
      
          <template slot="headerCell" slot-scope="props">

          <v-tooltip bottom>
              <span slot="activator">
              {{ props.header.text }}
              </span>
              <span>
              {{ props.header.text }}
              </span>
          </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">

          <td v-if="solicitacao">
              <v-checkbox
              primary
              hide-details
              v-model="props.selected"
              ></v-checkbox>
          </td>
        
          <td class="text-xs-center">{{ props.item.classificacao }}</td>
          <td class="text-xs-center">{{ props.item.grupo }}</td>
          <td class="text-xs-center">{{ props.item.subgrupo }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          </template>
      </v-data-table>    
    </v-card-text>
    <v-card-text style="text-align: center; width: 100%" align-content-center v-if="solicitacao">

      <v-data-table
          ref="selecaoTodos"
          hide-actions
          :headers="headers"
          :items="criterios"
          v-model="selected"
          item-key="id"
          select-all
          class="elevation-1"
      >
      
          <template slot="headerCell" slot-scope="props">

          <v-tooltip bottom>
              <span slot="activator">
              {{ props.header.text }}
              </span>
              <span>
              {{ props.header.text }}
              </span>
          </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">

          <td v-if="solicitacao">
              <v-checkbox
              primary
              hide-details
              v-model="props.selected"
              ></v-checkbox>
          </td>
        
          <td class="text-xs-center">{{ props.item.classificacao }}</td>
          <td class="text-xs-center">{{ props.item.grupo }}</td>
          <td class="text-xs-center">{{ props.item.subgrupo }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          </template>
      </v-data-table>    
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <div v-if="!makerlab">
        <div v-if="botaosaved">
          <v-btn color="primary" v-if="!btnedit" flat @click.stop="saved">Salvar</v-btn>
          <v-btn color="primary" v-if="btnedit" flat @click.stop="edit">OK</v-btn>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: [
    'criterios',
    'titulo',
    'solicitacao',
    'botaosaved',
    'btnedit',
    'makerlab'
  ],
  data () {
    return {
      search: '',
      selected: [],
      headers: [
        {text: 'Classificação', value: 'classificacao'},
        {text: 'Grupo', value: 'grupo'},
        {text: 'Subgrupo', value: 'subgrupo'},
        {text: 'Habilidade ou Competência', value: 'name'}
      ]

    }
  },
  mounted () {
    if (!this.botaosaved) {
      this.$watch('selected', function () {
        this.$emit('saved', this.selected)
      })
    }
  },
  methods: {
    saved () {
      this.$emit('saved', this.selected)
      this.$emit('scrool')
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reusable/showCriterio.vue